<template>
    <div>
        <div class="vx-col w-full mb-base">
            <!-- start:outbound info -->
            <vs-card class="p-4 mb-6">
                <div class="mb-4">
                    <h4 class="font-medium" style="font-size: 20px; font-weight: 500;">Outbound Info</h4>
                </div>

                <!-- Row 1: Reference | Route | Status -->
                <div style="display: flex; border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden;">
                    <div style="flex: 1; padding: 12px 16px; border-right: 1px solid #d1d5db;">
                        <label style="font-size: 14px; font-weight: 600; color: #000000; text-transform: uppercase;">Reference</label>
                        <p style="font-size: 18px; margin-top: 4px;">{{ outboundDetail.outbound_reference }}</p>
                    </div>
                    <div style="flex: 1; padding: 12px 16px; border-right: 1px solid #d1d5db;">
                        <label style="font-size: 14px; font-weight: 600; color: #000000; text-transform: uppercase;">Route</label>
                        <p style="font-size: 18px; margin-top: 4px;">{{ outboundDetail.origin ? outboundDetail.origin.name : '-' }} → {{ outboundDetail.destination ? outboundDetail.destination.name : '-' }}</p>
                    </div>
                    <div style="flex: 1; padding: 12px 16px;">
                        <label style="font-size: 14px; font-weight: 600; color: #000000; text-transform: uppercase;">Status</label>
                        <div style="margin-top: 8px;">
                            <span class="px-6 py-2 text-lg font-semibold text-white rounded-full" style="font-size: 16px;" :class="[statusBadge.color]">{{ statusBadge.text }}</span>
                        </div>
                    </div>
                </div>

                <!-- Row 2: Outstanding Product | Available Product -->
                <div style="display: flex; border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-top: 12px;">
                    <div style="flex: 1; padding-top: 12px; border-right: 1px solid #d1d5db;">
                        <label style="font-size: 14px; font-weight: 600; color: #000000; text-transform: uppercase; border-bottom: 1px solid #d1d5db; display: block;" class="px-4 pb-4">Outstanding Product</label>
                        <div>
                            <div v-for="(product, product_index) in products" :key="`outstanding-${product_index}`"
                                :style="{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: product_index % 2 === 0 ? '#f9fafb' : '#ffffff',
                                    borderBottom: product_index < products.length - 1 ? '1px solid #d1d5db' : 'none',
                                    padding: '0 12px'
                                }">
                                <span style="padding: 8px 0; font-size: 18px; font-weight: 700; color: #000000;">{{ product.total }}</span>
                                <span style="padding: 8px 0 8px 16px; font-size: 16px; color: #000000;">{{ product.code }}</span>
                            </div>
                        </div>
                    </div>
                    <div style="flex: 1; padding-top: 12px;">
                        <label style="font-size: 14px; font-weight: 600; color: #000000; text-transform: uppercase; border-bottom: 1px solid #d1d5db; display: block;" class="px-4 pb-4">Available Product</label>
                        <div>
                            <div v-for="(product, product_index) in products" :key="`available-${product_index}`"
                                :style="{
                                    display: 'flex',
                                    alignItems: 'center',
                                    backgroundColor: product_index % 2 === 0 ? '#f9fafb' : '#ffffff',
                                    borderBottom: product_index < products.length - 1 ? '1px solid #d1d5db' : 'none',
                                    padding: '0 12px'
                                }">
                                <span style="padding: 8px 0; font-size: 18px; font-weight: 700; color: #000000;">{{ product.total_base_qty }}</span>
                                <span style="padding: 8px 0 8px 16px; font-size: 16px; color: #000000;">{{ product.code }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </vs-card>
            <!-- end:outbound info -->

            <!-- start:tabs -->
            <vs-card class="p-4 mb-6">
                <div class="mb-4">
                    <h5 class="font-medium" style="font-size: 20px; font-weight: 500;">Item Check</h5>
                </div>

                <!-- Header: Reference | User ID | Aksi -->
                <div v-if="submittedProducts.length" style="display: flex; border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden; margin-bottom: 16px;">
                    <div style="flex: 1; padding: 12px 16px; border-right: 1px solid #d1d5db;">
                        <label style="font-size: 14px; font-weight: 600; color: #000000; text-transform: uppercase;">Reference</label>
                        <p style="font-size: 16px; margin-top: 4px;">{{ commitInfo.scanned_items.length ? commitInfo.scanned_items[0].do_reference : '-' }}</p>
                    </div>
                    <div style="flex: 1; padding: 12px 16px; border-right: 1px solid #d1d5db;">
                        <label style="font-size: 14px; font-weight: 600; color: #000000; text-transform: uppercase;">Username</label>
                        <p style="font-size: 16px; margin-top: 4px;">{{ commitInfo.scanned_items.length ? commitInfo.scanned_items[0].user : '-' }}</p>
                    </div>
                    <div style="flex: 1; padding: 12px 16px;">
                        <label style="font-size: 14px; font-weight: 600; color: #000000; text-transform: uppercase;">Aksi</label>
                        <div style="margin-top: 4px;">
                            <vs-button
                                color="success"
                                class="btn"
                                style="font-size: 16px; padding: 10px 24px;"
                                @click="openCloseConfirmation"
                                :disabled="!commitInfo.scanned_items.length"
                            >
                                Close DO
                            </vs-button>
                        </div>
                    </div>
                </div>

                <!-- Submitted Items -->
                <div v-if="submittedProducts.length" style="margin-bottom: 16px;">
                    <div style="border: 1px solid #d1d5db; border-radius: 8px; overflow: hidden;">
                        <div style="padding: 12px 16px; background-color: #f9fafb; border-bottom: 1px solid #d1d5db;">
                            <label style="font-size: 16px; font-weight: 600; color: #000000;">Submitted Items</label>
                        </div>
                        <div>
                            <div v-for="(product, product_index) in submittedProducts" :key="`submitted-product-${product_index}`"
                                :style="{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '10px 16px',
                                    borderBottom: product_index < submittedProducts.length - 1 ? '1px solid #d1d5db' : 'none'
                                }">
                                <span style="font-size: 16px; font-weight: 500;">{{ product.total_qty }}</span>
                                <span style="font-size: 16px; padding-left: 16px; color: #000000;">{{ product.code }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <vs-tabs :value="tabValue">
                            <vs-tab :label="formTabLabel">
                        <div class="vx-row">
                            <!-- TV Products -->
                            <div class="vx-col md:w-1/2 w-full">
                                <h6 class="mb-4 mt-4 text-2xl" style="font-weight: 600;">TV</h6>

                                <!-- With serial number: scan input -->
                                <vs-table v-if="useSerialNumber" max-items="10" :data="tvProducts" stripe search
                                    style="overflow-y: auto;">
                                    <template slot="thead">
                                        <vs-th>Product</vs-th>
                                        <vs-th>Scan Serial Number</vs-th>
                                        <vs-th>Action</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="item" v-for="(item, index) in data" :key="index"
                                            :v-show="item.status !== 'delete'">
                                            <vs-td style="padding-left: 16px;">
                                                {{ item.code }}
                                            </vs-td>

                                            <vs-td style="padding-left: 16px;">
                                                <vs-input class="w-full" v-model="scanInputs[item.code]"
                                                    @keyup.enter="() => { if (scanInputs[item.code]) submitItem(item) }" />
                                            </vs-td>

                                            <vs-td style="width: 10%">
                                                <div class="flex gap-x-3">
                                                    <vs-button color="primary" class="btn"
                                                        @click="() => submitItem(item)"
                                                        :disabled="!scanInputs[item.code]">Submit</vs-button>
                                                </div>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>

                                <!-- Without serial number: qty input -->
                                <vs-table v-else max-items="10" :data="tvProducts" stripe search
                                    style="overflow-y: auto;">
                                    <template slot="thead">
                                        <vs-th>Product</vs-th>
                                        <vs-th>Qty</vs-th>
                                        <vs-th>Open Qty</vs-th>
                                        <vs-th>Action</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="item" v-for="(item, index) in data" :key="index"
                                            :v-show="item.status !== 'delete'">
                                            <vs-td style="padding-left: 16px;">
                                                {{ item.code }}
                                            </vs-td>

                                            <vs-td style="width: 10%; padding-left: 16px;">
                                                <vs-input class="w-full" v-model="qtyInputs[item.code]" />
                                            </vs-td>

                                            <vs-td style="width: 10%; padding-left: 16px;">
                                                <vs-input class="w-full" :value="item.total" disabled />
                                            </vs-td>

                                            <vs-td style="width: 10%">
                                                <div class="flex gap-x-3">
                                                    <vs-button color="primary" class="btn"
                                                        @click="() => submitItem(item)"
                                                        :disabled="!(qtyInputs[item.code]) || (!item.total)">Submit</vs-button>
                                                </div>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>

                            <!-- Bracket TV Products -->
                            <div class="vx-col md:w-1/2 w-full">
                                <h6 class="mb-4 mt-4 text-2xl" style="font-weight: 600;">Bracket TV</h6>
                                <vs-table max-items="10" :data="bracketTvProducts" stripe search
                                    style="overflow-y: auto;">
                                    <template slot="thead">
                                        <vs-th>Product</vs-th>
                                        <vs-th>Qty</vs-th>
                                        <vs-th>Open Qty</vs-th>
                                        <vs-th>Action</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="item" v-for="(item, index) in data" :key="index"
                                            :v-show="item.status !== 'delete'">
                                            <vs-td style="padding-left: 16px;">
                                                {{ item.code }}
                                            </vs-td>

                                            <vs-td style="width: 20%; padding-left: 16px;">
                                                <vs-input class="w-full" v-model="qtyInputs[item.code]" />
                                            </vs-td>

                                            <vs-td style="width: 20%; padding-left: 16px;">
                                                <vs-input class="w-full" :value="item.total" disabled />
                                            </vs-td>

                                            <vs-td style="width: 20%">
                                                <div class="flex gap-x-3">
                                                    <vs-button color="primary" class="btn"
                                                        @click="() => submitItem(item)"
                                                        :disabled="!(qtyInputs[item.code]) || (!item.total)">Submit</vs-button>
                                                </div>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </div>
                    </vs-tab>

                    <vs-tab :label="submittedItemsTabLabel">
                        <div class="vx-row">
                            <!-- Submitted TV Items -->
                            <div class="vx-col md:w-1/2 w-full">
                                <h6 class="mb-4 mt-4 text-2xl" style="font-weight: 600;">TV</h6>
                                <p class="mb-4" style="font-size: 14px; color: #6b7280; font-weight: 500;">Total Submitted: {{ submittedTvItems.length }}</p>
                                <div>
                                    <vs-table max-items="10" :data="submittedTvItems" stripe pagination search>
                                    <template slot="thead">
                                        <vs-th>Product</vs-th>
                                        <vs-th>Description</vs-th>
                                        <vs-th v-if="useSerialNumber">Serial Number</vs-th>
                                        <vs-th>Qty</vs-th>
                                        <vs-th>Action</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="item" v-for="(item, index) in data" :key="index"
                                            :v-show="item.status !== 'delete'">
                                            <vs-td style="padding-left: 16px;">
                                                {{ item.product_code }}
                                            </vs-td>

                                            <vs-td style="padding-left: 16px;">
                                                {{ item.product_description_1 }}
                                            </vs-td>

                                            <vs-td v-if="useSerialNumber" style="padding-left: 16px;">
                                                {{ item.pack_id }}
                                            </vs-td>

                                            <vs-td style="padding-left: 16px;">
                                                {{ item.qty }}
                                            </vs-td>

                                            <vs-td style="width: 10%">
                                                <vs-button color="danger" class="btn" icon-pack="feather"
                                                    icon="icon-trash-2" @click="() => openCancelConfirmation(item)">
                                                    Cancel
                                                </vs-button>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                                </div>
                            </div>

                            <!-- Submitted Bracket TV Items -->
                            <div class="vx-col md:w-1/2 w-full">
                                <h6 class="mb-4 mt-4 text-2xl" style="font-weight: 600;">Bracket TV</h6>
                                <p class="mb-4" style="font-size: 14px; color: #6b7280; font-weight: 500;">Total Submitted: {{ submittedBracketTvItems.length }}</p>
                                <div>
                                    <vs-table max-items="10" :data="submittedBracketTvItems" stripe pagination search>
                                    <template slot="thead">
                                        <vs-th>Product</vs-th>
                                        <vs-th>Description</vs-th>
                                        <vs-th>Qty</vs-th>
                                        <vs-th>Action</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :data="item" v-for="(item, index) in data" :key="index"
                                            :v-show="item.status !== 'delete'">
                                            <vs-td style="padding-left: 16px;">
                                                {{ item.product_code }}
                                            </vs-td>

                                            <vs-td style="padding-left: 16px;">
                                                {{ item.product_description_1 }}
                                            </vs-td>

                                            <vs-td style="padding-left: 16px;">
                                                {{ item.qty }}
                                            </vs-td>

                                            <vs-td style="width: 10%">
                                                <vs-button color="danger" class="btn" icon-pack="feather"
                                                    icon="icon-trash-2" @click="() => openCancelConfirmation(item)">
                                                    Cancel
                                                </vs-button>
                                            </vs-td>
                                        </vs-tr>
                                    </template>
                                </vs-table>
                                </div>
                            </div>
                        </div>
                    </vs-tab>

                    <vs-tab :label="deliveryOrdersTabLabel">
                        <vs-table v-if="sortedDeliveryOrders.length" max-items="10" :data="sortedDeliveryOrders" stripe search>
                            <template slot="thead">
                                <vs-th>DO Number</vs-th>
                                <vs-th>DO Date</vs-th>
                                <vs-th>User</vs-th>
                                <vs-th>Driver</vs-th>
                                <vs-th>Vehicle Code</vs-th>
                                <vs-th>Action</vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <template v-for="(item, index) in data">
                                    <vs-tr v-if="item._isSeparator" :key="`separator-${index}`" style="pointer-events: none;">
                                        <vs-td colspan="6" style="padding: 0; border: none;">
                                            <div style="border-top: 2px dashed #d1d5db; margin: 4px 0;"></div>
                                        </vs-td>
                                    </vs-tr>
                                    <vs-tr v-else :data="item" :key="`do-${index}`">
                                        <vs-td style="padding-left: 16px;">
                                            {{ item.do_reference }}
                                        </vs-td>

                                        <vs-td style="padding-left: 16px;">
                                            <span>{{ item.created_at }}</span>
                                        </vs-td>

                                        <vs-td style="padding-left: 16px;">
                                            {{ item.user || '-' }}
                                        </vs-td>

                                        <vs-td style="padding-left: 16px;">
                                            <vs-input v-model="drivers[item.id]" @input="val => drivers[item.id] = val.charAt(0).toUpperCase() + val.slice(1)" />
                                        </vs-td>

                                        <vs-td style="padding-left: 16px;">
                                            <vs-input v-model="vehicleCodes[item.id]" @input="val => vehicleCodes[item.id] = val.toUpperCase()" />
                                        </vs-td>

                                        <vs-td style="width: 10%">
                                            <vs-button color="primary" class="btn" icon-pack="feather" icon="icon-printer"
                                                @click="() => printDO(item)">Print</vs-button>
                                        </vs-td>
                                    </vs-tr>
                                </template>
                            </template>
                        </vs-table>
                        <div v-else style="text-align: center; padding: 20px; color: #9ca3af; font-size: 12px;">
                            No delivery orders found
                        </div>
                    </vs-tab>
                </vs-tabs>
            </vs-card>
            <!-- end:tabs -->
        </div>
    </div>
</template>

<script>
export default {
    name: "GiVendorCommit",

    props: {
        useSerialNumber: {
            type: Boolean,
            default: false
        },
        closeDoEndpoint: {
            type: String,
            default: null
        },
        formTabLabel: {
            type: String,
            default: "Form"
        },
        submittedItemsTabLabel: {
            type: String,
            default: "Submitted Items"
        },
        deliveryOrdersTabLabel: {
            type: String,
            default: "Delivery Orders"
        }
    },

    data() {
        return {
            maxRetry: 10,

            commitInfo: {
                scanned_items: []
            },
            outboundDetail: {},

            tabValue: 0,
            isLoading: false,

            scanInputs: {},
            qtyInputs: {},
            drivers: {},
            vehicleCodes: {}
        }
    },

    computed: {
        doLength() {
            const { has_delivery_orders } = this.commitInfo

            if (!has_delivery_orders) return 0

            return has_delivery_orders.length
        },

        products() {
            const { outboundDetail } = this

            if (!outboundDetail || !outboundDetail.details) return []

            return (outboundDetail.details || []).reduce((products, item) => {
                const existed_product_index = products.findIndex(product => product.code == (item.product || {}).product_code)

                if (existed_product_index != -1) {
                    products[existed_product_index].items.push(item)
                    products[existed_product_index].total += parseInt(`${item.open_qty}`)
                    products[existed_product_index].total_base_qty += parseInt(`${item.inventory_qty}`)
                } else {
                    products.push({
                        total: parseInt(`${item.open_qty}`),
                        total_base_qty: parseInt(`${item.inventory_qty}`),
                        code: (item.product || {}).product_code,
                        items: [item],
                        description_1: item.product.description_1,
                        description_2: item.product.description_2,
                        is_tv: item.need_serial_number,
                        outbound_detail_id: item.id
                    })
                }

                return [...products]
            }, [])
        },

        tvProducts() {
            return this.products.filter(item => item.is_tv)
        },

        bracketTvProducts() {
            return this.products.filter(item => !item.is_tv)
        },

        submittedTvItems() {
            if (this.useSerialNumber) {
                return (this.commitInfo.scanned_items || []).filter(item => item.pack_id)
            }

            const tvProductCodes = this.tvProducts.map(item => item.code)
            return (this.commitInfo.scanned_items || []).filter(item => tvProductCodes.includes(item.product_code))
        },

        submittedBracketTvItems() {
            if (this.useSerialNumber) {
                return (this.commitInfo.scanned_items || []).filter(item => !item.pack_id)
            }

            const bracketTvProductCodes = this.bracketTvProducts.map(item => item.code)
            return (this.commitInfo.scanned_items || []).filter(item => bracketTvProductCodes.includes(item.product_code))
        },

        submittedProducts() {
            const allSubmitted = [
                ...this.submittedTvItems,
                ...this.submittedBracketTvItems
            ]

            return allSubmitted.reduce((products, item) => {
                const existedIndex = products.findIndex(p => p.code === item.product_code)

                if (existedIndex !== -1) {
                    products[existedIndex].total_qty += parseInt(`${item.qty}`)
                } else {
                    products.push({
                        code: item.product_code,
                        description_1: item.product_description_1,
                        description_2: item.product_description_2,
                        total_qty: parseInt(`${item.qty}`)
                    })
                }

                return [...products]
            }, [])
        },

        statusBadge() {
            const { outboundDetail } = this
            let color = 'bg-grey'

            if (outboundDetail.status) {
                switch ((outboundDetail.status || {}).name) {
                    case 'Fully Committed': {
                        color = 'bg-success'
                    } break;
                    case 'Partially Committed': {
                        color = 'bg-warning'
                    }
                }
            }

            return {
                color,
                text: (outboundDetail.status || {}).name
            }
        },

        resolvedCloseDoEndpoint() {
            if (this.closeDoEndpoint) return this.closeDoEndpoint
            return this.useSerialNumber
                ? '/tvd/outbound/deliveryorder/close/'
                : '/tvd/outbound/deliveryorder/close-without-sn/'
        },

        currentUser() {
            const user = (this.$store.state.user || {}).user || {};
            return user.username || '-';
        },

        sortedDeliveryOrders() {
            const orders = this.commitInfo.has_delivery_orders || []
            if (!orders.length) return []

            const sortByDateDesc = (a, b) => {
                const dateA = new Date(a.created_at)
                const dateB = new Date(b.created_at)
                return dateB - dateA
            }

            const lastDoId = this.commitInfo.last_do ? this.commitInfo.last_do.id : null

            const userOrders = orders
                .filter(item => item.id === lastDoId)
                .sort(sortByDateDesc)

            const otherOrders = orders
                .filter(item => item.id !== lastDoId)
                .sort(sortByDateDesc)

            return [
                ...userOrders,
                ...(userOrders.length && otherOrders.length ? [{ _isSeparator: true }] : []),
                ...otherOrders
            ]
        }
    },

    watch: {
        isLoading(val) {
            if (val) this.$vs.loading();
            else this.$vs.loading.close();
        },

        'commitInfo.has_delivery_orders'(newVal) {
            if (newVal) {
                newVal.forEach(item => {
                    if (this.drivers[item.id] === undefined) {
                        this.$set(this.drivers, item.id, item.driver)
                    } else if (this.drivers[item.id] === undefined) {
                        this.$set(this.drivers, item.id, '')
                    }

                    if (this.vehicleCodes[item.id] === undefined) {
                        this.$set(this.vehicleCodes, item.id, item.vehicle_code)
                    } else if (this.vehicleCodes[item.id] === undefined) {
                        this.$set(this.vehicleCodes, item.id, '')
                    }
                })
            }
        },

        'commitInfo.last_do'(newVal) {
            if (newVal && newVal.id) {
                if (this.drivers[newVal.id] === undefined) {
                    this.$set(this.drivers, newVal.id, newVal.driver)
                }
                if (this.vehicleCodes[newVal.id] === undefined) {
                    this.$set(this.vehicleCodes, newVal.id, newVal.vehicle_code)
                }
            }
        }
    },

    methods: {
        initializeQtyInputs() {
            this.products.forEach(product => {
                if (this.useSerialNumber && product.is_tv) {
                    this.$set(this.qtyInputs, product.code, '1')
                } else {
                    this.$set(this.qtyInputs, product.code, `${product.total}`)
                }
            })
        },

        async submitItem(item) {
            const { warehouse_id, outbound_id } = this.$route.params
            const qty = this.useSerialNumber && item.is_tv
                ? '1'
                : this.qtyInputs[item.code]

            if (!qty) {
                this.$vs.notify({
                    color: "danger",
                    title: "Submit gagal",
                    iconPack: "feather",
                    icon: "icon-alert-triangle",
                    text: "Qty tidak bisa kosong"
                })
                return;
            }

            const request = {
                warehouse_id,
                outbound_id,
                outbound_detail_id: item.outbound_detail_id,
                qty
            }

            if (this.useSerialNumber && item.is_tv) {
                request.serial_number = this.scanInputs[item.code]
            }

            try {
                this.isLoading = true

                const res = await this.storeDODetail(request)

                if (res && res.data && res.data.success) {
                    this.commitInfo = res.data

                    this.$vs.notify({
                        color: "success",
                        title: "Submit berhasil",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "Produk terkait berhasil disubmit"
                    })

                    if (this.useSerialNumber && item.is_tv) {
                        this.scanInputs[item.code] = ''
                    }

                    const commitInfoRes = await this.searchByOutbound()
                    if (commitInfoRes && commitInfoRes.data) {
                        this.commitInfo = commitInfoRes.data
                        this.outboundDetail = commitInfoRes.data.outbound || {}
                    }

                    this.initializeQtyInputs()
                    this.isLoading = false
                }
            } catch (error) {
                this.handleError(error)
                this.isLoading = false
            }
        },

        storeDODetail(request) {
            const payload = {
                warehouse_id: request.warehouse_id,
                outbound_id: request.outbound_id,
                outbound_detail_id: request.outbound_detail_id,
                qty: request.qty
            }

            if (request.serial_number) {
                payload.serial_number = request.serial_number
            }

            return this.$http.post(`/tvd/outbound/deliveryorder/store`, payload)
        },

        searchByOutbound() {
            const { outbound_id, warehouse_id } = this.$route.params

            return this.$http.get(`/tvd/outbound/deliveryorder/searchByOutbound/${outbound_id}`, {
                params: {
                    warehouse_id
                }
            })
        },

        fetchAllData() {
            this.isLoading = true
            this.maxRetry = this.maxRetry - 1

            this.searchByOutbound()
                .then(commitInfoRes => {
                    if (commitInfoRes && commitInfoRes.data) {
                        this.commitInfo = commitInfoRes.data
                        this.outboundDetail = commitInfoRes.data.outbound || {}
                    }
                    this.initializeQtyInputs()
                    this.isLoading = false
                })
                .catch(() => {
                    if (this.maxRetry < 0) {
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.fetchAllData()
                                this.maxRetry = 10
                            },
                            cancel: () => this.$router.go(-1),
                            acceptText: 'Yes',
                            cancelText: 'No'
                        })
                        return;
                    }

                    this.fetchAllData()

                    this.isLoading = false
                })
        },

        cancelItem(item) {
            this.isLoading = true

            this.$http.delete(`/tvd/outbound/deliveryorder/destroyDoDetail/${item.id}`)
                .then(async res => {
                    if (res && res.data && res.data.success) {
                        this.$vs.notify({
                            color: "success",
                            title: "Cancel Submit berhasil",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: "Produk terkait berhasil dibatalkan"
                        })

                        const commitInfoRes = await this.searchByOutbound()
                        if (commitInfoRes && commitInfoRes.data) {
                            this.commitInfo = commitInfoRes.data
                            this.outboundDetail = commitInfoRes.data.outbound || {}
                        }

                        this.isLoading = false
                    }
                })
                .catch(error => {
                    this.handleError(error)
                    this.isLoading = false
                })
        },

        openCancelConfirmation(item) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirmation',
                text: 'Are you sure to cancel the submitted items?',
                accept: () => this.cancelItem(item),
                acceptText: 'Yes',
                cancelText: 'No'
            })
        },

        openCloseConfirmation() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirmation',
                text: 'Are you sure to close the submission of this item?',
                accept: () => this.closeDO(),
                acceptText: 'Yes',
                cancelText: 'No'
            })
        },

        closeDO() {
            this.isLoading = true

            const { warehouse_id, outbound_id } = this.$route.params

            const submittedItem = this.commitInfo.scanned_items[0]

            if (!submittedItem) {
                this.$vs.notify({
                    color: "danger",
                    title: "Failed to close",
                    iconPack: "feather",
                    icon: "icon-alert-triangle",
                    text: "The selected item has not been submitted"
                })
            }

            this.$http.post(`${this.resolvedCloseDoEndpoint}${submittedItem.do_id}`, {
                warehouse_id,
                outbound_id
            })
                .then(async res => {
                    if (res && res.data && res.data.success) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: "DO has been closed successfully"
                        })

                        const commitInfoRes = await this.searchByOutbound()
                        if (commitInfoRes && commitInfoRes.data) {
                            this.commitInfo = commitInfoRes.data
                            this.outboundDetail = commitInfoRes.data.outbound || {}
                        }

                        this.isLoading = false
                    }
                })
                .catch(error => {
                    this.handleError(error)
                    this.isLoading = false
                })
        },

        printDO(item) {
            this.isLoading = true

            const driver = this.drivers[item.id]
            const vehicle_code = this.vehicleCodes[item.id]

            this.$http.post(`/tvd/outbound/deliveryorder/print/${item.id}`, {
                driver,
                vehicle_code
            }, {
                responseType: 'blob'
            })
                .then(res => {
                    const blob_file = new Blob([res.data], {
                        type: 'application/pdf'
                    })
                    window.open(URL.createObjectURL(blob_file))

                    this.isLoading = false
                })
                .catch(error => {
                    this.handleError(error)

                    this.isLoading = false
                })
        }
    },

    mounted() {
        this.fetchAllData()
    }
}
</script>

<style>
.vs-tabs-primary button.btn:not(:disabled):hover {
    color: #fff !important;
}
</style>

<style scoped>
/* Override font sizes for vs-table in tabs */
.vs-table {
    font-size: 15px;
}
.vs-table th {
    font-size: 15px;
    font-weight: 600;
}
.vs-table td {
    font-size: 15px;
}
.vs-table--header {
    font-size: 15px;
}

/* Tab section titles */
h6.mb-4.mt-4.text-lg.font-bold {
    font-size: 15px;
    font-weight: 600;
}

/* No data text */
.vs-table--not-data {
    font-size: 12px !important;
}
.vs-table td[colspan] {
    font-size: 12px !important;
}
</style>

<style>
/* Non-scoped styles for tab titles - override Vuesax defaults */
.vs-tabs--li button {
    font-size: 15px !important;
    font-weight: 600 !important;
}

/* No data text - global override */
.vs-table--not-data {
    font-size: 12px !important;
}
</style>
